module.exports = __webpack_public_path__ + "img/porntube.6f2d562.png";